/**
 * Orders-page fulfillment labels.
 *
 * Pending vs completed must match `PENDING_FULFILLMENT_STATUSES` and
 * `COMPLETED_FULFILLMENT_STATUSES` in `shared/lib/order_status.py`.
 * `shared/tests/unit/test_order_status.py` fails if these lists drift.
 * Picked stays on the pending side: the tray is done in syncBase, and
 * packing plus shipping happen outside this app.
 */

export const PENDING_FULFILLMENT_STATUSES = [
  'ready',
  'on_hold',
  'picked',
  'fulfillment_queued',
  'label_created',
  'error_retry',
] as const;

export const COMPLETED_FULFILLMENT_STATUSES = [
  'shipped',
  'delivered',
  'cancelled',
] as const;

export function fulfillmentStatusLabel(
  status: string | null | undefined,
  emptyLabel = 'Unknown',
): string {
  if (!status || !status.trim()) {
    return emptyLabel;
  }
  const normalized = status.trim().toLowerCase();
  if (normalized === 'picked') {
    return 'Picked';
  }
  return normalized
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function fulfillmentStatusesForGroup(group: 'pending' | 'completed'): readonly string[] {
  return group === 'pending' ? PENDING_FULFILLMENT_STATUSES : COMPLETED_FULFILLMENT_STATUSES;
}
